const evaluatePropertyExpression = (rule, assetTypeCodes, options) => {
    const assetTypeCode = assetTypeCodes?.find(item => item.assetTypeId === options.assetTypeId)?.code;
    if (!assetTypeCode) return null;
  
    if (options.value > rule.assetMinValue && options.value <= rule.assetMaxValue && rule.assetTypes.includes(assetTypeCode)) {
      return rule.value;
    }
    return null;
  };

export { evaluatePropertyExpression};